import { application } from "./application"

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import EventFilterController from "./event_filter_controller"
application.register("event-filter", EventFilterController)

import KeyboardController from "./keyboard_controller"
application.register("keyboard", KeyboardController)

import ScorePickerController from "./score_picker_controller"
application.register("score-picker", ScorePickerController)

import OverlayController from "./overlay_controller"
application.register("overlay", OverlayController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)
